import Order from "@api/types/order";
import React from "react";

import OrderHistoryListItem from "@components/OrderHistoryListItem";

import { Container, Header, HeaderSpan, OrderList, ScrollContainer } from "./styles";

type OrderHistoryTableProps = {
  data: Order[];
};

type OrderHistoryTableState = {
  activeOrderKey: number;
  currentSort: string;
  sortedData: Order[];
};

export default class OrderHistoryTable extends React.Component<
  OrderHistoryTableProps,
  OrderHistoryTableState
> {
  constructor(props) {
    super(props);
    this.state = {
      sortedData: [],
      activeOrderKey: -1,
      currentSort: "orderNumber",
    };
  }

  async setActive(index) {
    if (index === this.state.activeOrderKey) {
      this.setState({
        activeOrderKey: -1,
      });
    } else {
      this.setState({
        activeOrderKey: index,
      });
    }
  }

  setSortData(parameter: string) {
    let modifiedParameter = parameter;
    if (this.state.currentSort === parameter) {
      modifiedParameter = "-" + parameter;
    }
    this.setState({
      sortedData: this.props.data.sort(this.dynamicSort(modifiedParameter)),
      currentSort: modifiedParameter,
      activeOrderKey: -1,
    });
  }

  dynamicSort(property): (a: Order, b: Order) => number {
    let sortOrder = 1;
    if (property[0] === "-") {
      sortOrder = -1;
      property = property.substr(1);
    }
    return function (a: Order, b: Order) {
      let result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
      return result * sortOrder;
    };
  }

  render() {
    return (
      <Container>
        <ScrollContainer>
          <Header>
            <HeaderSpan>Order Number</HeaderSpan>
            <HeaderSpan>Date</HeaderSpan>
            <HeaderSpan>Status</HeaderSpan>
            <HeaderSpan>PO Number</HeaderSpan>
            <HeaderSpan>Total</HeaderSpan>
          </Header>
          <OrderList>
            {this.props.data.map((order, index) => (
              <OrderHistoryListItem
                key={index}
                order={order}
                visible={index === this.state.activeOrderKey}
                onClick={() => this.setActive(index)}
              />
            ))}
          </OrderList>
        </ScrollContainer>
      </Container>
    );
  }
}
